import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18LinkchannelG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      children: [/*#__PURE__*/jsx("path", {
        d: "M16.337 11.053a.643.643 0 0 0-.643.643v2.708c0 .712-.577 1.29-1.29 1.292H3.575a1.29 1.29 0 0 1-1.288-1.292V3.573a1.29 1.29 0 0 1 1.289-1.287h2.707a.643.643 0 0 0 0-1.286H3.575A2.58 2.58 0 0 0 1 3.575v10.83a2.58 2.58 0 0 0 2.575 2.575h10.83a2.58 2.58 0 0 0 2.575-2.574v-2.708a.643.643 0 0 0-.643-.645"
      }), /*#__PURE__*/jsx("path", {
        d: "M16.93 1.398A.65.65 0 0 0 16.337 1H10.15a.643.643 0 1 0 0 1.286h4.634L9.695 7.375a.643.643 0 0 0 .91.909l5.089-5.089v4.636a.643.643 0 1 0 1.286 0V1.643a.6.6 0 0 0-.05-.245"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18LinkchannelG$1 = Svg18LinkchannelG;

export { Svg18LinkchannelG$1 as default };
